import { useContext } from 'react';

import { SalesOrderFormContext } from '../../contexts/SalesOrderFormContext';
import {
  BuyerAdditionalDetailsAndDocumentsSection,
  BuyerDealDetailsSection,
  BuyerFinancialDetails,
  BuyerLogisticsSection,
  BuyerMaterialDetailsSection,
  BuyerPartiesSection,
} from '..';

export const SalesOrderFormSections = () => {
  const { documents: uploadedDocuments } = useContext(SalesOrderFormContext);

  return (
    <>
      <BuyerPartiesSection />
      <BuyerMaterialDetailsSection />
      <BuyerDealDetailsSection />
      <BuyerLogisticsSection />
      <BuyerFinancialDetails />
      <BuyerAdditionalDetailsAndDocumentsSection uploadedDocuments={uploadedDocuments} />
    </>
  );
};
